/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Verbis_AriaInputs */

const tr_legal_footer_verbis_aria = /** @type {(inputs: Legal_Footer_Verbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK VERBİS Başvuru No 1779704748 (Onay Sürecinde)`)
};

const en_legal_footer_verbis_aria = /** @type {(inputs: Legal_Footer_Verbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK VERBİS application number 1779704748 (approval pending)`)
};

const de_legal_footer_verbis_aria = /** @type {(inputs: Legal_Footer_Verbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK VERBİS Antragsnummer 1779704748 (im Genehmigungsverfahren)`)
};

const ru_legal_footer_verbis_aria = /** @type {(inputs: Legal_Footer_Verbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявление KVKK VERBİS № 1779704748 (на рассмотрении)`)
};

/**
* | output |
* | --- |
* | "KVKK VERBİS application number 1779704748 (approval pending)" |
*
* @param {Legal_Footer_Verbis_AriaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_verbis_aria = /** @type {((inputs?: Legal_Footer_Verbis_AriaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Verbis_AriaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_verbis_aria(inputs)
	if (locale === "de") return de_legal_footer_verbis_aria(inputs)
	if (locale === "ru") return ru_legal_footer_verbis_aria(inputs)
	return tr_legal_footer_verbis_aria(inputs)
});